import { render, staticRenderFns } from "./batch.vue?vue&type=template&id=3c0a8142&scoped=true&"
import script from "./batch.vue?vue&type=script&lang=js&"
export * from "./batch.vue?vue&type=script&lang=js&"
import style0 from "./batch.vue?vue&type=style&index=0&id=3c0a8142&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0a8142",
  null
  
)

export default component.exports